import { useExperienceBuilderContext } from "components/ExperienceBuilderEG/context/ExperienceBuilderContext";
import { Button } from "shared";
import { ButtonVariants } from "shared/Button/Button";
import LocationFilters from "../Courses/LocationFilters";
import ToursList from "./ToursList";
import DOMPurify from "dompurify";
import GoogleMap from "../GoogleMap";

export type TToursDetails = {
  additionalRequirements: string;
};

function Tours() {
  const { setActiveStep, labels } = useExperienceBuilderContext();

  return (
    <div className="m-courses">
      <div className="u-wrapper">
        <Button
          extraClass="back-btn"
          text="Back"
          variant={ButtonVariants.Naked}
          onClick={() => setActiveStep("hotels")}
        />
        <h2 className="a-title__main">{labels.Tours.Title}</h2>
        <div className="a-title__short-text">
          <p
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(labels.Tours.Description),
            }}
          ></p>
        </div>
      </div>
      <hr className="u-divider" />

      <div className="u-wrapper">
        <div className="m-courses__content">
          <div className="m-courses__content--left">
            <LocationFilters />
            <ToursList />
          </div>
          <div>
            <GoogleMap />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Tours;
